module.exports = __webpack_public_path__ + "static/img/login-logo.c85c8bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login-logo.png
// module id = nkOi
// module chunks = 1